/**
 * Read a cookie value from `document.cookie` on the client.
 *
 * Use when a value must be sent explicitly in a request payload because cookie
 * forwarding is unreliable (e.g. requests initiated from an embedded iframe may
 * not attach cookies). Returns `undefined` during SSR, when the cookie is absent,
 * or when cookie access is unavailable.
 */
export function getClientCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined

  try {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
    return match ? decodeURIComponent(match[1]) : undefined
  } catch {
    return undefined
  }
}
